import Api from '@/providers/Api'
import { required } from 'vuelidate/lib/validators'

const categoryOptions = {
    NO_STICKER: 'No sticker',
    STICKER_ERROR: 'Sticker does not match',
    EXPIRED_STICKER: 'Expired sticker',
    CONTROL_ISSUE: 'Emissions control does not match',
}

const statusOptions = {
    NO_ISSUE: 'No Issues',
    ISSUE: 'Issue',
    VIOLATION: 'Violation',
    RESOLVED: 'Resolved',
}

export default {
    categoryOptions,
    statusOptions,
    fields: {
        equipment: {
            dbFieldName: 'equipment',
            label: 'Equipment',
            type: 'multiselect',
            multiselectOptions: {
                placeholder: 'VIN / Serial # / Registration #',
                label: 'vehicleString',
                multiple: false,
            },
            async doSearch (query, modelInstance) {
                const filters = {
                    vehicleString: { field: 'vehicleString', type: 'hidden', value: query },
                    canAddToAudit: { field: 'canAddToAudit', type: 'hidden', value: modelInstance.audit_id }
                }
                return Api.getItems(this, 'equipment', filters)
            },
            validations: {
                required,
            },
            invalidFeedback: {
                required: 'Equipment is required',
            }
        },
        statusCreate: {
            dbFieldName: 'status',
            label: 'Status',
            type: 'radios',
            helpTag: 'audit-equipment-status-create',
            options: [
                { value: 'NO_ISSUE', text: 'No Issue' },
                { value: 'ISSUE', text: 'Has Issue' },
                { value: 'VIOLATION', text: 'In Violation' },
            ],
            validations: { required }
        },
        status: {
            label: 'Status',
            type: 'radios',
            options: [
                { value: 'NO_ISSUE', text: 'No Issue' },
                { value: 'ISSUE', text: 'Has Issue' },
                { value: 'VIOLATION', text: 'In Violation' },
                { value: 'RESOLVED', text: 'Resolved' },
            ],
            validations: { required }
        },
        category: {
            label: 'Issue / Violation Category',
            type: 'radios',
            options: [
                { value: 'NO_STICKER', text: 'No sticker' },
                { value: 'STICKER_ERROR', text: 'Sticker does not match' },
                { value: 'EXPIRED_STICKER', text: 'Expired sticker' },
                { value: 'CONTROL_ISSUE', text: 'Emissions control does not match' },
            ],
            showIf (model) {
                return model.status !== 'NO_ISSUE'
            },
        },
        resolved_reason: {
            label: 'Reason for Resolving',
            type: 'text',
            showIf (model) {
                return model.status === 'RESOLVED'
            },
        },
        follow_up: {
            label: 'Follow-up Date',
            type: 'date',
            validations: {
                required_unless_no_issue: async function (value) {
                    let status = this.$v.form.status?.$model
                    if (status && status === 'NO_ISSUE') {
                        return true
                    }
                    return !!value
                }
            }
        },
        comment: {
            label: 'Notes',
            type: 'textarea'
        },

    }
}
